import { EnabledDisabled } from '@reliance/types/enums/EnabledDisabled';
import { GamesFilters } from '@reliance/types/filters/GamesFilters';
import { PaginationFilters } from '@reliance/types/filters/PaginationFilters';
import { FacilityGame } from '@reliance/types/models/FacilityGame';
import { Game } from '@reliance/types/models/Game';
import { useAsync } from 'react-async-hook';
import api from '../common/api';
import { IPaginatedResponse } from '../common/reliance-api-service';

export function useGames(filters?: GamesFilters) {
  return useAsync<Game[]>(
    () => api.get<Game[]>('/game', { params: filters }).then((res) => res.data),
    [filters]
  );
}

type FacilityGamesFilters = PaginationFilters & {
  facilityId?: number;
  status?: EnabledDisabled;
};

export function useFacilityGames(filters?: FacilityGamesFilters) {
  return useAsync<IPaginatedResponse<FacilityGame>>(
    () => api.get<IPaginatedResponse<FacilityGame>>('/game/facility', { params: filters }).then((res) => res.data),
    [filters]
  );
}
